var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-checkbox',{attrs:{"name":"check-button","switch":"","title":_vm.switchTitle},on:{"change":_vm.saveSwitchState},model:{value:(_vm.form.is_representative),callback:function ($$v) {_vm.$set(_vm.form, "is_representative", $$v)},expression:"form.is_representative"}})
}
var staticRenderFns = []

export { render, staticRenderFns }